
import { defineComponent, PropType } from 'vue'

// Composables
import { Facet, UseFacetedSearch } from '@/use/faceted-search'

// Components
import SearchFacetList from '@/components/SearchFacetList.vue'

export default defineComponent({
  name: 'SearchFacets',
  components: { SearchFacetList },

  props: {
    facetedSearch: {
      type: Object as PropType<UseFacetedSearch>,
      required: true,
    },
    facets: {
      type: Array as PropType<Facet[]>,
      required: true,
    },
  },
})
